import classNames from 'classnames';
import { useIntl } from 'react-intl';

import { Button } from '@/components/Button';
import { Icon } from '@/components/Icon';
import { useToggleProgramFollow } from '@/modules/library/hooks/useToggleProgramFollow';

interface ProgramFollowProps {
  programUUID: string;
  iconOnly?: boolean;
}

export const ProgramFollow = ({ programUUID, iconOnly = false }: ProgramFollowProps) => {
  const { formatMessage } = useIntl();
  const { isProgramFollowed, toggleFollow } = useToggleProgramFollow(programUUID);

  const ariaLabel = formatMessage({
    id: `programScreen.accessibility.${isProgramFollowed ? 'unfollow' : 'follow'}`,
  });

  return (
    <Button style="light" onClick={toggleFollow} ariaLabel={ariaLabel}>
      <Icon
        name={isProgramFollowed ? 'bell-on' : 'bell'}
        className={classNames('text-xl', { 'fill-transparent': !isProgramFollowed })}
      />
      {!iconOnly &&
        formatMessage({
          id: isProgramFollowed ? 'program.unfollow' : 'program.follow',
        })}
    </Button>
  );
};
